import { render, staticRenderFns } from "./IntegrationCard.vue?vue&type=template&id=28e09270&scoped=true&"
import script from "./IntegrationCard.vue?vue&type=script&lang=ts&"
export * from "./IntegrationCard.vue?vue&type=script&lang=ts&"
import style0 from "./IntegrationCard.vue?vue&type=style&index=0&id=28e09270&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e09270",
  null
  
)

export default component.exports